<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label="Tìm theo Khóa học"
                  class="border border-primary rounded p-50"
                  label-class="pb-25"
                >
                  <b-row>
                    <b-col cols="6">
                      <v-select
                        v-model="filter.trainingSystemId"
                        :options="trainingSystems"
                        :reduce="option => option.value"
                        :placeholder="trainingSystemLabel"
                        @input="onTrainingSystemsChange"
                      />
                    </b-col>
                    <b-col cols="6">
                      <v-select
                        v-model="filter.courseId"
                        :options="courses"
                        :reduce="option => option.value"
                        placeholder="Khóa học"
                      />
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Tìm theo Học phần"
                  class="border border-primary rounded p-50"
                  label-class="pb-25"
                >
                  <b-row>
                    <b-col cols="6">
                      <v-select
                        v-model="filter.departmentId"
                        :options="departments"
                        :reduce="option => option.value"
                        placeholder="Khoa/Bộ môn"
                        @input="onDepartmentChange"
                      />
                    </b-col>
                    <b-col cols="6">
                      <v-select
                        v-model="filter.subjectId"
                        :options="subjects"
                        :reduce="option => option.value"
                        placeholder="Học phần"
                      />
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="6"
              >
                <b-col
                  cols="12"
                  class="pl-0 d-flex"
                >
                  <b-form-file
                    ref="inputFileRef"
                    class="w-100"
                    placeholder="Chọn file để import đề cương..."
                    drop-placeholder="Drop file here..."
                    accept=".xls, .xlsx"
                    @change="importExcel"
                  />
                  <b-button
                    v-show="showTableImport && creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="ml-1"
                    @click="cancelImportSubject"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="XIcon" /> Hủy bỏ import
                    </span>
                  </b-button>
                  <b-button
                    v-show="showTableImport && creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="info"
                    class="ml-1"
                    @click="handleImportSubject"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="CheckSquareIcon" /> Import học phần
                    </span>
                  </b-button>
                </b-col>
              </b-col>
              <b-col
                cols="6"
              >
                <div class="text-right">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="warning"
                    @click="downloadFile"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="DownloadIcon" /> Tải file mẫu
                    </span>
                  </b-button>

                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="ml-1"
                    @click="onSearchMainData"
                  >
                    <feather-icon icon="FilterIcon" /> Lọc
                  </b-button>
                  <b-button
                    v-if="true"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.syllabusSaveModal
                    variant="success"
                    class="ml-1"
                    @click="onCreateSyllabus"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="PlusIcon" /> Thêm mới
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row class="">
              <b-col cols="12">
                <div class="d-flex align-items-center mb-1 mt-1">
                  <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                    đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                  </span>
                </div>
                <vue-good-table
                  v-show="!showTableImport"
                  mode="remote"
                  class="my-table"
                  row-style-class="vgt-row"
                  style-class="vgt-table striped bordered"
                  :columns="columns"
                  :rows="syllabuses"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  @on-page-change="onPageChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'status'">
                      {{ getStatusName(props.row.status) }}
                    </span>
                    <span
                      v-else-if="props.column.field === 'action'"
                      class="thead-group-action"
                    >
                      <b-button-group>
                        <b-button
                          v-if="updatable"
                          v-b-modal.syllabusSaveModal
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="btn-icon"
                          size="sm"
                          title="Chỉnh sửa"
                          @click="onEditSyllabus(props.row)"
                        >
                          <feather-icon icon="Edit2Icon" />
                        </b-button>
                        <b-dropdown
                          right
                          variant="success"
                        >
                          <b-dropdown-item
                            v-if="structureCreatable"
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="success"
                            class="btn-icon"
                            size="sm"
                            @click="onOpenStructure(props.row)"
                          >
                            <feather-icon icon="SettingsIcon" />
                            Cấu hình đề cương
                          </b-dropdown-item>

                        </b-dropdown>
                        <b-button
                          v-if="deletable"
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="danger"
                          class="btn-icon"
                          size="sm"
                          @click="onDeleteSyllabus(props.row)"
                        >
                          <feather-icon icon="TrashIcon" />
                        </b-button>
                      </b-button-group>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
                <vue-good-table
                  v-show="showTableImport"
                  :columns="tableImport.columns"
                  :rows="tableImport.data"
                  :pagination-options="paginationOptions"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị 1 đến </span>
                        <b-form-select
                          v-model="filterTableExcel.itemsPerPage"
                          :options="filterTableExcel.itemsPerPageOptions"
                          class="mx-1"
                          @input="
                            (value) =>
                              props.perPageChanged({ currentPerPage: value })
                          "
                        />
                        <span
                          class="text-nowrap"
                        >của {{ props.total }} bản ghi</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="filterTableExcel.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="
                            (value) => props.pageChanged({ currentPage: value })
                          "
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <SyllabusSave
      ref="syllabusSaveModal"
      :syllabus="currentMainData"
      @succeed="onSucceed"
    />
    <b-modal
      id="syllabusStructureModal"
      size="xl"
      centered
      title="Cấu hình đề cương"
      hide-footer
    >
      <SyllabusStructure
        :syllabus="currentMainData"
        @succeed="onSucceed"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BDropdown,
  BButtonGroup,
  BDropdownItem,
  BCard,
  BCol,
  BContainer,
  BFormSelect,
  BOverlay,
  BPagination,
  BRow,
  VBTooltip,
  BFormGroup, BFormFile,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { getUser } from '@/auth/utils'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { OrganizationCode, PermissionCode, ResourceCode } from '@/const/code'
import SyllabusSave from '@/views/main/syllabus/SyllabusSave.vue'
import * as XLSX from 'xlsx'
import { Workbook } from '@syncfusion/ej2-excel-export'
import { ApiCode } from '@/const/api'
import SyllabusStructure from '@/views/main/syllabus/SyllabusStructure.vue'
import apiCommon from '@/views/apiCommon'
import { STATUSES } from '@/const/status'
import api from './api'

export default {
  name: 'Syllabus',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    SyllabusStructure,
    BFormFile,
    SyllabusSave,
    BButton,
    BDropdown,
    BButtonGroup,
    BDropdownItem,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
    BFormGroup,
    vSelect,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        trainingSystemId: null,
        courseId: null,
        departmentId: null,
        subjectId: null,
        code: null,
        name: null,
        status: null,
      },
      syllabuses: [],
      totalRows: 0,
      trainingSystems: [],
      courses: [],
      departments: [],
      subjects: [],
      statuses: STATUSES,
      dataExcel: [],
      fileName: null,
      paginationOptions: {
        enabled: true,
      },
      columns: [
        {
          label: 'STT',
          field: 'rowNum',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Mã đề cương',
          field: 'code',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            placeholder: 'Tìm theo mã',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Tên đề cương',
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            placeholder: 'Tìm theo tên',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Khóa',
          field: 'courseName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Học phần',
          field: 'subjectName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterOptions: {
            enabled: true,
            filterDropdownItems: [],
            placeholder: 'Tất cả',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Thao tác',
          field: 'action',
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center',
        },
      ],
      tableImport: {
        columns: [
          {
            label: 'STT',
            field: 'rowNum',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            label: 'Mã đề cương',
            field: 'code',
            sortable: false,
            thClass: 'text-center',
          },
          {
            label: 'Tên đề cương',
            field: 'name',
            sortable: false,
            thClass: 'text-center',
          },
          {
            label: 'Mã khóa học',
            field: 'courseCode',
            sortable: false,
            thClass: 'text-center',
          },
          {
            label: 'Mã học phần',
            field: 'subjectCode',
            sortable: false,
            thClass: 'text-center',
          },
        ],
        data: [],
        totalRows: 0,
      },
      showTableImport: false,
      currentMainData: undefined,
      itemsPerPageOptions: [10, 20, 30, 50, 100],
      filterTableExcel: {
        currentPage: 1,
        itemsPerPage: 10,
        itemsPerPageOptions: [20, 30, 50, 80, 100],
      },
    }
  },
  computed: {
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.SYLLABUS)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.SYLLABUS)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.SYLLABUS)
    },
    structureCreatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.SYLLABUS_STRUCTURE)
    },
    trainingSystemLabel() {
      return getUser().orgCode === OrganizationCode.HLUV ? 'Hệ đào tạo' : 'Hình thức đào tạo'
    },
  },
  async created() {
    this.isLoading = true
    try {
      const [trainingSystemsRes, coursesRes, departmentsRes, subjectsRes, syllabusesRes] = await Promise.all([
        apiCommon.getTrainingSystems(),
        apiCommon.getCourses(),
        apiCommon.getDepartments(),
        apiCommon.getSubjects(),
        api.getSyllabuses(this.filter),
      ])
      this.trainingSystems = trainingSystemsRes
      this.courses = [...coursesRes.courses]
      this.departments = departmentsRes
      this.subjects = subjectsRes
      this.setSyllabusData(syllabusesRes)
      const statusesCV = this.statuses.map(item => ({
        value: item.value,
        text: item.label,
      }))
      this.$set(
        this.columns[5].filterOptions,
        'filterDropdownItems',
        statusesCV,
      )
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    async onTrainingSystemsChange(event) {
      this.filter.courseId = null
      const { courses } = await apiCommon.getCourses({ trainingSystemId: event })
      this.courses = courses
    },
    async onDepartmentChange(event) {
      this.filter.subjectId = null
      this.subjects = await apiCommon.getSubjects({ departmentId: event })
    },
    setSyllabusData({ records, total }) {
      this.syllabuses = records
      this.totalRows = total
    },
    onCreateSyllabus() {
      this.currentMainData = undefined
    },
    onEditSyllabus(mainData) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = mainData
      this.currentMainData = rest
    },
    onDeleteSyllabus(syllabus) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa đề cương học phần <span class="text-danger">${syllabus.name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await api.deleteSyllabus(syllabus.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                try {
                  this.setSyllabusData(await api.getSyllabuses(this.filter))
                } catch (e) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `[${e.code}] ${e.message}`,
                      icon: 'XCircleIcon',
                      variant: 'danger',
                    },
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getSyllabusesFromStore()
    },
    async getSyllabusesFromStore() {
      this.isLoading = true
      try {
        this.setSyllabusData(await api.getSyllabuses(this.filter))
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getSyllabusesFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      const updates = {}
      if ('name' in columnFilters) updates.name = columnFilters.name?.trim() || null
      if ('code' in columnFilters) updates.code = columnFilters.code?.trim() || null
      if ('status' in columnFilters) updates.status = columnFilters.status || null
      this.updateParams(updates)
      await this.getSyllabusesFromStore()
    },
    getStatusName(id) {
      return this.statuses.find(status => status.value === id).label
    },
    async onSucceed() {
      await this.getSyllabusesFromStore()
    },
    async onSearchMainData() {
      await this.getSyllabusesFromStore()
    },
    async importExcel(e) {
      const { files } = e.target
      if (!files.length) {
        return
      }
      if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.showToast('Vui lòng chọn file Excel (.xls, .xlsx)', 'XCircleIcon', 'danger', '')
        return
      }
      if (files[0].name) {
        this.fileName = files[0].name
      }
      this.readFile(files)
    },
    readFile(files) {
      const fileReader = new FileReader()
      fileReader.onload = async ev => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, { type: 'binary' })
          const wsname = workbook.SheetNames[0]
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            header: 0,
            defval: '',
            raw: false,
          })
          if (!ws.length) {
            this.showToast('File không có dữ liệu', 'XCircleIcon', 'danger', '')
            return
          }
          const requiredHeaders = [
            'STT', 'MA_DE_CUONG', 'TEN_DE_CUONG', 'MA_KHOA_HOC', 'MA_HOC_PHAN',
            'MA_DIEM_CHUNG', 'TRONG_SO', 'MA_DIEM_HOC_PHAN',
          ]
          const fileHeaders = Object.keys(ws[0])
          const missingHeaders = requiredHeaders.filter(h => !fileHeaders.includes(h))
          if (missingHeaders.length) {
            this.showToast(`File thiếu cột: ${missingHeaders.join(', ')}`, 'XCircleIcon', 'danger', '')
            return
          }
          const grouped = new Map()
          let currentKey = null

          for (let i = 0; i < ws.length; i++) {
            const row = ws[i]
            if (row.STT) {
              currentKey = row.STT.toString().trim()
              grouped.set(currentKey, {
                code: row.MA_DE_CUONG.trim(),
                name: row.TEN_DE_CUONG.trim(),
                courseCode: row.MA_KHOA_HOC.trim(),
                subjectCode: row.MA_HOC_PHAN.trim(),
                generalWeights: [],
              })
            }
            const syllabus = grouped.get(currentKey)
            if (!syllabus) continue
            const generalCode = row.MA_DIEM_CHUNG.trim()
            const generalWeight = row.TRONG_SO !== '' ? parseFloat(row.TRONG_SO.replace(',', '.')) : null
            const componentCode = row.MA_DIEM_HOC_PHAN.trim()
            let general = syllabus.generalWeights.find(g => g.generalScoreCode === generalCode)
            if (!general) {
              general = {
                generalScoreCode: generalCode,
                weight: generalWeight,
                components: [],
              }
              syllabus.generalWeights.push(general)
            }
            general.components.push({
              componentScoreCode: componentCode,
            })
          }
          const result = Array.from(grouped.values()).map((item, idx) => ({
            ...item,
            rowNum: idx + 1,
          }))
          this.dataExcel = result
          this.showToast('Đọc file thành công!', 'CheckIcon', 'success', '')
          this.showTableImport = true
          this.tableImport.data = result
          this.tableImport.totalRows = result.length
        } catch (e) {
          this.showToast('Lỗi khi đọc file Excel', 'XCircleIcon', 'danger', e.toString())
        }
      }
      fileReader.readAsBinaryString(files[0])
    },
    resetInputFile() {
      this.$refs.inputFileRef.reset()
    },
    async handleImportSubject() {
      this.isLoading = true
      try {
        const res = await api.importSyllabus(this.dataExcel)
        if (res.code === ApiCode.SUCCESS) {
          this.showToast(res.message, 'CheckIcon', 'success')
          this.resetInputFile()
          await this.getSyllabusesFromStore()
          this.showTableImport = false
        } else {
          this.showToast(res.message, 'XCircleIcon', 'danger', 3000)
          this.resetInputFile()
          this.showTableImport = false
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger', 3000)
        this.resetInputFile()
        this.showTableImport = false
      } finally {
        this.isLoading = false
      }
    },
    downloadFile() {
      const columns = [
        { index: 1, width: 50 }, // STT
        { index: 2, width: 200 }, // MA_DE_CUONG
        { index: 3, width: 200 }, // TEN_DE_CUONG
        { index: 4, width: 200 }, // MA_KHOA_HOC
        { index: 5, width: 200 }, // MA_HOC_PHAN
        { index: 6, width: 200 }, // MA_DIEM_CHUNG
        { index: 7, width: 100 }, // TRONG_SO
        { index: 8, width: 200 }, // MA_DIEM_HOC_PHAN
      ]
      const borderStyle = {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      }
      const textStyle = {
        fontName: 'Times New Roman',
        fontSize: 13,
        hAlign: 'left',
        ...borderStyle,
      }
      const headerStyle = {
        ...borderStyle,
        fontColor: '#ffffff',
        backColor: '#4472C4',
        fontName: 'Times New Roman',
        fontSize: 13,
        hAlign: 'center',
      }
      const rows = []
      rows.push({
        index: 1,
        cells: [
          { index: 1, value: 'STT', style: headerStyle },
          { index: 2, value: 'MA_DE_CUONG', style: headerStyle },
          { index: 3, value: 'TEN_DE_CUONG', style: headerStyle },
          { index: 4, value: 'MA_KHOA_HOC', style: headerStyle },
          { index: 5, value: 'MA_HOC_PHAN', style: headerStyle },
          { index: 6, value: 'MA_DIEM_CHUNG', style: headerStyle },
          { index: 7, value: 'TRONG_SO', style: headerStyle },
          { index: 8, value: 'MA_DIEM_HOC_PHAN', style: headerStyle },
        ],
      })
      let index = 2
      const rowData = [
        {
          stt: 1, code: 'DE6', name: 'Đề cương 6', khoa: 'DH18', hocPhan: 'CNGD70116', diemChung: 'score1', trongSo: 0.2, diemHP: 'score1',
        },
        {
          stt: '', code: '', name: '', khoa: '', hocPhan: '', diemChung: 'score1', trongSo: '', diemHP: 'score2',
        },
        {
          stt: '', code: '', name: '', khoa: '', hocPhan: '', diemChung: 'score2', trongSo: 0.3, diemHP: 'score4',
        },
        {
          stt: '', code: '', name: '', khoa: '', hocPhan: '', diemChung: 'score3', trongSo: 0.5, diemHP: 'score5',
        },
        {
          stt: 2, code: 'DE7', name: 'Đề cương 7', khoa: 'DH18', hocPhan: 'CNGD70117', diemChung: 'score1', trongSo: 0.2, diemHP: 'score1',
        },
        {
          stt: '', code: '', name: '', khoa: '', hocPhan: '', diemChung: 'score1', trongSo: '', diemHP: 'score2',
        },
        {
          stt: '', code: '', name: '', khoa: '', hocPhan: '', diemChung: 'score2', trongSo: 0.3, diemHP: 'score4',
        },
        {
          stt: '', code: '', name: '', khoa: '', hocPhan: '', diemChung: 'score3', trongSo: 0.5, diemHP: 'score5',
        },
      ]
      for (const data of rowData) {
        rows.push({
          index,
          cells: [
            { index: 1, value: data.stt, style: textStyle },
            { index: 2, value: data.code, style: textStyle },
            { index: 3, value: data.name, style: textStyle },
            { index: 4, value: data.khoa, style: textStyle },
            { index: 5, value: data.hocPhan, style: textStyle },
            { index: 6, value: data.diemChung, style: textStyle },
            { index: 7, value: data.trongSo, style: textStyle },
            { index: 8, value: data.diemHP, style: textStyle },
          ],
        })
        index++
      }
      const worksheets = [{ columns, rows }]
      const workbook = new Workbook({ worksheets }, 'xlsx')
      workbook.save('mauImportDeCuong.xlsx')
    },
    cancelImportSubject() {
      this.showTableImport = false
      this.resetInputFile()
    },
    showToast(title, icon, variant, autoHideDelay = 1000) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
          autoHideDelay,
        },
      })
    },
    onOpenStructure(row) {
      this.currentMainData = row
      this.$bvModal.show('syllabusStructureModal')
    },
  },
}
</script>
